import { Box, Typography } from '@mui/material';
import { CaretRight, SquaresFour } from 'phosphor-react';
import { Fragment } from 'react';

type StepsProps = {
  items: string[];
};

export const Steps = ({ items }: StepsProps) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <SquaresFour size={24} />
      <CaretRight size={16} color='#C8C3C8' />
      {items.map((item, index) => {
        return (
          <Fragment key={index}>
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: index + 1 === items.length ? '600' : '400',
              }}
              textTransform='capitalize'
            >
              {item}
            </Typography>
            {index + 1 < items.length && (
              <CaretRight size={16} color='#C8C3C8' />
            )}
          </Fragment>
        );
      })}
    </Box>
  );
};
